import { SORT_DIRECTIONS } from 'app/shared/componentsRestyled/common/TooltipedSortLabel';

export const TaskTableCellId = {
  EXPAND: 'expand',
  NAME: 'name',
  LAST_MODIFIED: 'lastModified',
  STATUS: 'status',
  ACTIONS: 'actions',
};

export const taskTableCellWidthMap = {
  [TaskTableCellId.EXPAND]: '48px',
  [TaskTableCellId.NAME]: '46%',
  [TaskTableCellId.LAST_MODIFIED]: '20%',
  [TaskTableCellId.STATUS]: '20%',
  [TaskTableCellId.ACTIONS]: '10%',
};

export const taskTableDefaultOrder = {
  id: TaskTableCellId.NAME,
  direction: SORT_DIRECTIONS.ASC,
};
